import styled from "styled-components";
import { color } from "../../styles";

export const ContentWrapper = styled.div`
    padding: 16px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    border-radius: 8px;
    background-color: ${color.emphasis.NEUTRAL_N0};
    flex: 1;
    overflow: hidden;
    box-shadow: none;
`;

export const FormWrapper = styled.div`
    margin-top: 16px;
    height: inherit;
    flex-direction: column;
    justify-content: flex-start;
    gap: 12px;
    display: flex;
`;

export const FormTitle = styled.div`
    display: flex;
    font-size: 22px;
    font-style: normal;
    font-weight: 700;
    line-height: 28px;
    border-left: 5px solid var(--Primary-Blue-B100, #0058a0);
    padding-left: 20px;
    text-align: center;
`;

export const FormRow = styled.div`
    display: flex;
    align-items: flex-start;
`;

export const Label = styled.label`
    text-align: right;
    width: 160px;
    font-size: 14px;
    font-weight: 600;
    color: #333;
    line-height: 18px;
    padding-right: 8px;
    word-break: break-word;
    min-height: 36px;
    display: flex;
    align-items: center;
    justify-content: flex-end;
`;

export const InputWrapper = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
    max-width: 655px;
`;

export const Input = styled.input<{ isError?: boolean }>`
    flex: 1;
    width: 100%;
    box-sizing: border-box;
    padding: 6px 10px;
    border: 1px solid ${(props) => (props.isError ? "#ff0000" : color.emphasis.NEUTRAL_N70)};
    border-radius: 5px;
    line-height: 24px;
    font-size: 13px;
    height: 36px;
    font-family: "Noto Sans";

    &:focus {
        outline: none;
        border-color: ${(props) => (props.isError ? "#ff0000" : color.primary.BLUE_B100)};
        box-shadow: 0 0 0 2px rgba(0, 88, 160, 0.12);
    }

    &::placeholder {
        color: ${color.secondary.DARK_GREY};
        font-size: 15px;
        font-style: normal;
        line-height: 22px;
        font-weight: 300;
    }

    &:disabled {
        opacity: 0.5;
    }
`;

export const ToggleWrapper = styled.div`
    display: flex;
    align-items: center;
    margin-bottom: 8px;
    margin-top: 8px;
`;

export const ToggleContainer = styled.label`
    position: relative;
    display: inline-block;
    width: 42px;
    height: 26px;
    margin-right: 8px;
`;

export const ToggleInput = styled.input<{ disabled?: boolean }>`
    opacity: 0;
    width: 0;
    height: 0;

    &:checked + span {
        background-color: ${color.primary.BLUE_B100};
    }

    &:checked + span:before {
        transform: translateX(16px);
    }

    &:focus + span {
        box-shadow: 0 0 1px ${color.primary.BLUE_B100};
    }

    &:disabled + span {
        opacity: 0.4;
        cursor: not-allowed;
    }
`;

export const ToggleSlider = styled.span<{ disabled?: boolean }>`
    position: absolute;
    cursor: ${props => props.disabled ? 'not-allowed' : 'pointer'};
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: ${color.emphasis.NEUTRAL_N10};
    transition: 0.4s;
    border-radius: 26px;

    &:before {
        position: absolute;
        content: "";
        height: 22px;
        width: 22px;
        left: 2px;
        bottom: 2px;
        background-color: white;
        transition: 0.4s;
        border-radius: 50%;
    }
`;

export const ToggleText = styled.span<{ disabled?: boolean }>`
    font-size: 14px;
    color: #333;
    opacity: ${(props) => (props.disabled ? 0.5 : 1)};
`;

export const RequiredAsterisk = styled.span`
    color: #ff0000;
    margin-left: 2px;
`;

export const ErrorMessage = styled.span`
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    color: #ff0000;
    font-size: 14px;
    letter-spacing: 0.2px;
    margin-top: 10px;
`;

export const InputContainer = styled.div`
    display: flex;
    flex: 1;
    x-direct on: c mn;
`;

export const InfoWrapper = styled.div`
    display: flex;
    flex-direction: column;
    gap: 20px;
`;

export const MultiSelectWrapper = styled.div`
    position: relative;
    width: 100%;
    max-width: 655px;
`;

export const DropdownContainer = styled.div`
    border: 1px solid ${color.emphasis.NEUTRAL_N70};
    border-radius: 5px;
    padding: 6px 10px;
    min-height: 36px;
    cursor: pointer;
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 4px;
    background: white;
    box-sizing: border-box;
    &:hover {
        border-color: ${color.emphasis.NEUTRAL_N70};
    }

    .placeholder {
        color: ${color.secondary.DARK_GREY};
        font-size: 15px;
        font-style: normal;
        line-height: 22px;
        font-weight: 300;
    }
`;

export const OptionsContainer = styled.div`
    position: absolute;
    top: 100%;
    left: 0;
    right: 0;
    background: white;
    border: 1px solid ${color.emphasis.NEUTRAL_N70};
    border-radius: 5px;
    margin-top: 2px; // Reduced from 4px to 2px
    max-height: 200px;
    overflow-y: auto;
    z-index: 1000;
    box-shadow: 0 2px 4px rgba(0,0,0,0.1);
`;

export const OptionItem = styled.div`
    padding: 6px 12px; // Reduced from 8px to 6px
    display: flex;
    align-items: center;
    gap: 8px;
    cursor: pointer;
    &:hover {
        background-color: #f5f5f5;
    }
`;

export const CheckboxInput = styled.input`
    cursor: pointer;
    width: 16px;
    height: 16px;
`;

export const OptionLabel = styled.label`
    cursor: pointer;
    font-size: 14px;
    color: #333;
`;

export const SelectedItem = styled.div`
    display: inline-flex;
    align-items: center;
    background: #f5f5f5;
    border-radius: 4px;
    padding: 2px 8px; // Reduced from 4px to 2px
    margin: 2px;
    font-size: 14px;
`;

export const RemoveButton = styled.button`
    background: none;
    border: none;
    margin-left: 4px;
    cursor: pointer;
    padding: 0 4px;
    color: #666;
    &:hover {
        color: #ff0000;
    }
`;

export const AutocompleteDropdown = styled.div`
    position: absolute;
    top: 100%;
    left: 0;
    right: 0;
    max-height: 200px;
    overflow-y: auto;
    background-color: white;
    border: 1px solid ${color.emphasis.NEUTRAL_N70};
    border-radius: 4px;
    z-index: 1000;
    margin-top: 4px;
    box-shadow: 0 2px 4px rgba(0,0,0,0.1);
    font-family: Noto Sans;

    &:disabled {
        opacity: 0.5;
    }
`;

export const AutocompleteDropdownItem = styled.div`
    padding: 8px 12px;
    cursor: pointer;
    border-bottom: 1px solid #f0f0f0;
    background-color: white;
    transition: background-color 0.2s;
    font-family: Noto Sans;

    &:hover {
        background-color: #f5f5f5;
    }

    &:last-child {
        border-bottom: none;
    }
`;